<template>
  <div>
    <confirmation-dialog
      hide-open-button
      message-title="REMOVER VALOR"
      message-body="TEM CERTEZA QUE DESEJA REMOVER O VALOR?"
      @yes="evOnRemoveValueAccepted"
      v-model="showRemoveValueDialog"
    />

    <b-modal
      id="view_hosting_type_value"
      title="EDITAR VALOR"
      no-close-on-backdrop
      hide-footer
      @show="evOnShow"
      @shown="evOnShown"
      @hide="evOnHide"
    >
      <b-form @submit.prevent="evOnSubmit">
        <b-row>
          <b-col>
            <label-required-field label="Valor" />
            <b-input
              ref="value"
              :disabled="!permission('edit', 'type_of_hosting')"
              type="text"
              v-model="value"
              @keyup="handleValueUpdate"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Descrição</label>
            <b-input
              :disabled="!permission('edit', 'type_of_hosting')"
              type="text"
              v-model="description"
            />
          </b-col>
        </b-row>
        <warning-message
          v-if="!permission('edit', 'type_of_hosting')"
          message="Você não tem permissão para modificar tipos de hospedagens"
        />
        <warning-required-fields v-if="permission('edit', 'type_of_hosting')" />
        <errors-messages :errors="errors" />
        <b-row>
          <b-col>
            <v-btn
              class="btn-cancel"
              @click="$bvModal.hide('view_hosting_type_value')"
            >
              CANCELAR
            </v-btn>
          </b-col>
          <b-col cols="auto">
            <v-btn
              v-if="permission('remove', 'type_of_hosting')"
              class="btn-delete ml-2"
              @click="showRemoveValueDialog = true"
            >
              <i class="fas fa-trash mr-2 text-twenty"></i>
              EXCLUIR
            </v-btn>
            <v-btn
              v-if="permission('edit', 'type_of_hosting')"
              :disabled="loading"
              type="submit"
              class="btn-save ml-2"
            >
              <i class="fas fa-save mr-2 text-twenty"></i>
              {{ loading ? "Carregando" : "SALVAR" }}
            </v-btn>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { formatPrice, formatValueOnKeyUp } from "../../lib/format";
import permission from "../../lib/permission";
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import ConfirmationDialog from "../Components/ConfirmationDialog.vue";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField.vue";
import WarningMessage from "../Components/WarningMessage.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields.vue";

export default {
  name: "ViewValue",

  components: {
    WarningMessage,
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
    ConfirmationDialog,
  },

  props: {
    type_of_hosting_value: Object,
  },

  data() {
    return {
      errors: [],
      loading: false,

      showRemoveValueDialog: false,

      value: "",
      description: "",
    };
  },

  watch: {
    type_of_hosting_value() {
      if (!this.type_of_hosting_value) return;

      this.$bvModal.show("view_hosting_type_value");
    },
  },

  methods: {
    permission,

    async evOnShow() {
      this.errors = [];
      this.loading = false;

      this.value = formatPrice(this.type_of_hosting_value.value);
      this.description = this.type_of_hosting_value.description;
    },

    async evOnShown() {
      this.$refs.value.focus();
    },

    async evOnHide() {
      this.$emit("close");
    },

    async evOnRemoveValueAccepted() {
      try {
        const data = { id: this.type_of_hosting_value.id };

        const response = await api.delete(
          "/rest-home/hosting-type-value/delete",
          { data }
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          toast(message, "success");
          this.$bvModal.hide("view_hosting_type_value");
          this.$emit("updated");
        }
      } catch (error) {
        console.log(error);
      }
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          id: this.type_of_hosting_value.id,
          value: this.value,
          description: this.description,
        };
        const response = await api.put(
          "/rest-home/hosting-type-value/update",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          toast(message, "success");
          this.$bvModal.hide("view_hosting_type_value");
          this.$emit("updated");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    handleValueUpdate: function (e) {
      this.value = formatValueOnKeyUp(e.target.value);
    },
  },
};
</script>

<style>
</style>